import { render } from "./Add_record.vue?vue&type=template&id=30c534ae&scoped=true"
import script from "./Add_record.vue?vue&type=script&lang=js"
export * from "./Add_record.vue?vue&type=script&lang=js"

import "./Add_record.vue?vue&type=style&index=0&id=30c534ae&lang=css"
import "./Add_record.vue?vue&type=style&index=1&id=30c534ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c534ae"]])

export default __exports__